import logo from "@/assets/lors-logo.svg";

const LorsLogoBanner = () => (
  <div className="bg-background border-b border-border">
    <div className="container max-w-[1200px] mx-auto px-6 py-6 flex justify-center">
      <img
        src={logo}
        alt="Law Office of Ruby Steinbrecher"
        width={400}
        height={56}
        decoding="async"
        fetchPriority="high"
        className="h-10 md:h-14 w-auto"
      />
    </div>
  </div>
);

export default LorsLogoBanner;
